import React from 'react';
import PropTypes from 'prop-types';

import firebase from '../../common/firebase';
import { Container } from '../../common/base';
import { Grid, Col, Anchor } from '../../common/interfaces';
import { CtaWrapper, CtaBox, CtaBoxButton } from './Styled';
import { withTranslation } from '../../common/libs/i18n';

class HomeBottomCta extends React.Component {
  static propTypes = {
    t: PropTypes.func
  };

  constructor(props) {
    super();
    const { t } = props;
    this.state = {
      buttonURL: '/signin',
      buttonText: t('landing.closing.button_go_create_account', 'Create Account')
    };
    this.unsubscribe = undefined;
  }

  componentDidMount() {
    const { t } = this.props;

    this.unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          buttonURL: '/dashboard',
          buttonText: t('landing.closing.button_go_dashboard', 'Go to Dashboard')
        });
      } else {
        this.setState({
          buttonURL: '/signin',
          buttonText: t('landing.closing.button_go_create_account', 'Create Account')
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    const { t } = this.props;
    const { buttonURL, buttonText } = this.state;
    return (
      <CtaWrapper>
        <Container>
          <CtaBox>
            <Grid align="center">
              <Col lg={8} md={12}>
                <h2>{t('landing.closing.title', 'Ready to Get Started?')}</h2>
                <p>
                  {t(
                    'landing.closing.subtitle',
                    'Create account to convert your Rupiah into IDRT, or IDRT into Rupiah.'
                  )}
                </p>
              </Col>
              <Col lg={4} md={12}>
                <CtaBoxButton>
                  <Anchor href={buttonURL} type="button" size="large">
                    {buttonText}
                  </Anchor>
                </CtaBoxButton>
              </Col>
            </Grid>
          </CtaBox>
        </Container>
      </CtaWrapper>
    );
  }
}

export default withTranslation('common')(HomeBottomCta);
